const Items = [
  {
    id: 1,
    mainImage: "https://i.ibb.co/XxXtzm3S/Screenshot-2026-02-17-002817.png",
    img: [
      "https://i.ibb.co/yFmTZBBB/Screenshot-2026-02-17-002737.png",
      "https://i.ibb.co/27MDP2gP/Screenshot-2026-02-17-002801.png",
      "https://i.ibb.co/XxXtzm3S/Screenshot-2026-02-17-002817.png",
      "https://i.ibb.co/ymJHLw8t/Screenshot-2026-02-17-002903.png",
      "https://i.ibb.co/MkJfkZ6J/Screenshot-2026-02-17-002943.png",
      "https://i.ibb.co/zhMHq6bp/Screenshot-2026-02-17-002958.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682700374/Blog%20Portfolio%20Gilbert/Project/msnproduction/img-7_uhh453.png",
    ],
    features: [
      "Home",
      "Login",
      "JobDetails",
      "Filter",
      "Search",
      "Navigation to Company Web",
      "Responsive Design",

      "404 Page and many more.",
    ],
    technologies: [
      "React",
      "TailwindCSS",
      "React Hooks",
      "React icons",
      "Authentication",
    ],
    title: "Jobby App",
    description:
      "Jobby Application is a job searching application. It allows user to search, sort, view jobs ",
    category: "business",
    liveLink: "https://jjjobby.ccbp.tech/",
    codeLink: "https://github.com/jjpradi/jjjobby/",
  },
  {
    id: 2,
    mainImage: "https://i.ibb.co/zKDyS3k/Screenshot-2026-02-19-211503.png",
    img: [
      "https://i.ibb.co/qY0YbzQ1/Screenshot-2026-02-19-211442.png",
      "https://i.ibb.co/zKDyS3k/Screenshot-2026-02-19-211503.png",
      "https://i.ibb.co/whqPMZcZ/Screenshot-2026-02-19-211405.png",
      "https://i.ibb.co/WW8wZPzG/Screenshot-2026-02-19-211416.png",
      "https://i.ibb.co/hJmCGyyG/Screenshot-2026-02-19-211306.png",
      "https://i.ibb.co/qY0YbzQ1/Screenshot-2026-02-19-211442.png",
      "https://i.ibb.co/zKDyS3k/Screenshot-2026-02-19-211503.png",
      "https://i.ibb.co/whqPMZcZ/Screenshot-2026-02-19-211405.png",
      "https://i.ibb.co/WW8wZPzG/Screenshot-2026-02-19-211416.png",
      "https://i.ibb.co/hJmCGyyG/Screenshot-2026-02-19-211306.png",
    ],
    features: [
      "User registration and login",
      "Authentication using JWT Tokens",
      "Story searching and pagination",
      "CRUD operations (Story create, read, update and delete)",
      "Upload user ımages and story ımages to the server",
      "Liking stories and adding stories to the Reading list",
      "Commenting on the story",
      "Skeleton loading effect",
      "Responsive Design",
      "404 Page and many more.",
    ],
    technologies: [
      "React",
      "React Hooks",
      "React Icons",
      "Axios",
      "CSS",
      "UUID",
      "NodeJS",
      "ExpressJS",
      "MongoDB",
      "Mongoose",
      "Express Asynsc Handler",
      "Json Web Token",
      "Bcryptjs",
      "Nodemailer",
      "Dontenv",
      "Multer",
      "Slugify",
      "Cors",
    ],
    title: "Book Hub",
    description:
      "Fullstack open source blogging application made with MongoDB, Express, React & Nodejs (MERN)",
    category: "personal",
    liveLink: "https://jjbook.vercel.app/",
    codeLink: "https://github.com/jjpradi/jjbook",
  },
  {
    id: 3,
    mainImage:
      "https://i.ibb.co/WWQr6BDc/Screenshot-2026-02-20-190823.png",
    img: [
      "https://i.ibb.co/twjYbNbk/Screenshot-2026-02-20-190606.png",
      "https://i.ibb.co/QFZmWqDk/Screenshot-2026-02-20-190643.png",
      "https://i.ibb.co/6JgHrm3B/Screenshot-2026-02-20-190700.png",
      "https://i.ibb.co/WWQr6BDc/Screenshot-2026-02-20-190823.png",
      "https://i.ibb.co/QZ7fWkR/Screenshot-2026-02-20-190742.png",
      "https://i.ibb.co/FL5PjmMj/Screenshot-2026-02-20-190950.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312772/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-7_twij3j.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312773/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-8_njclct.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312774/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-9_zg1jfe.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312772/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-10_yag7bj.png",
    ],
    features: [
      "User registration and login",
      "Authentication using JWT Tokens",
      "Add Favorites",
      "Delete Favorites",
      "Leave a Reviews",
      "Delete Reviews",
      "Password Update",
      "Search Live",
      "Watch the trailer on Youtube",
      "404 Page and many more",
      "Skeleton loading effect",
      "DarkMode",
      "DarkMode",
      "Responsive Design",
    ],
    technologies: [
      "React",
      "React Hooks",
      "React Router Dom",
      "Axios",
      "Material UI",
      "CK Editor",
      "Formik",
      "React Redux",
      "React Toastify",
      "Swiper",
      "NodeJS",
      "ExpressJS",
      "Mongoose",
      "Json Web Token",
      "Cookie Parser",
      "Cors",
      "Dontenv",
      "Express Validator",
      "Nodemon",
      "MongoDB",
      "TMDB API",
    ],
    title: "MovieDB",
    description:
      "Fullstack open source movie application made with MongoDB, Express, React & Nodejs (MERN)",
    category: "personal",
    liveLink: "https://movie-databse-ivaq.vercel.app/",
    codeLink: "https://github.com/jjpradi/movieDB",
  },
  {
    id: 4,
    mainImage: "https://i.ibb.co/bjwFxT3d/Screenshot-2026-02-17-011841.png",
    img: [
      "https://i.ibb.co/bjwFxT3d/Screenshot-2026-02-17-011841.png",
      "https://i.ibb.co/HLMMR9jf/Screenshot-2026-02-17-011904.png",
      "https://i.ibb.co/v6Y1bHS8/Screenshot-2026-02-17-011925.png",
      "https://i.ibb.co/gbb3y2m3/Screenshot-2026-02-17-011941.png",
      "https://i.ibb.co/Wp3qzwrv/Screenshot-2026-02-17-012111.png",
      "https://i.ibb.co/ccndgKwx/Screenshot-2026-02-17-010429.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682772432/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-18_zpsewd.png",
    ],
    features: [
      "Login ",
      "Home",
      "Prime section",
      "Products",
      "Add Cart",
      "Edit Product",
      "Remove Product",
      "404 Page and many more",
      "Responsive Design",
    ],
    technologies: [
      "React",
      "React Hooks",
      "React Icons",

      "Tailwind CSS",
      "LocalStorage",

      "Node JS",
      "Express JS",

      "JWT",

      "Cookie Parser",
    ],
    title: "NxtTrendz e-commerce Application",
    description: "NxtTrendz App is e-commerce similar to Amazon and Flipkart.",
    category: "business",
    liveLink: "https://jjtrendz.ccbp.tech",
    codeLink: "https://github.com/jjtrendz",
  },

  {
    id: 7,
    mainImage:
      "https://res.cloudinary.com/du541igfh/image/upload/v1682944695/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-3_t6uxoj.png",
    img: [
      "https://res.cloudinary.com/du541igfh/image/upload/v1682944091/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-1_gqero4.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682944091/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-2_ukjdh2.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682944695/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-3_t6uxoj.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682944091/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-4_btevir.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682944091/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-5_oakjx2.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682944092/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-6_pqefy9.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682944091/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-7_wfrvb7.png",
    ],
    features: [
      "User registration and login",
      "Select the type of question and the difficulty level of the question",
      "Juis time is running and after the time is up it stops automatically",
      "The final results of the answers answered will be shown",
      "Incorrect and correct answer results will be displayed",
      "Responsive Design",
    ],
    technologies: [
      "React",
      "React Vite",
      "Tailwind CSS",
      "Firebase Authentication",
      "Framer Motion",
      "React Firebase Hooks",
      "React Icons",
    ],
    title: "Bert Quiz",
    description: "Fullstack open source quiz application",
    category: "personal",
    liveLink: "https://bertquiz.vercel.app/",
    codeLink: "https://github.com/",
  },

{
    id: 8,
    mainImage: "https://i.ibb.co/8wntQ64/Screenshot-2026-04-18-170639.png",
    img: [
      "https://i.ibb.co/bjwFxT3d/Screenshot-2026-02-17-011841.png",
      "https://i.ibb.co/HLMMR9jf/Screenshot-2026-02-17-011904.png",
      "https://i.ibb.co/v6Y1bHS8/Screenshot-2026-02-17-011925.png",
      "https://i.ibb.co/gbb3y2m3/Screenshot-2026-02-17-011941.png",
      "https://i.ibb.co/Wp3qzwrv/Screenshot-2026-02-17-012111.png",
      "https://i.ibb.co/ccndgKwx/Screenshot-2026-02-17-010429.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682772432/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-18_zpsewd.png",
    ],
    features: [
      "Login ",
      "Home",
      "Prime section",
      "Products",
      "Add Cart",
      "Edit Product",
      "Remove Product",
      "404 Page and many more",
      "Responsive Design",
    ],
    technologies: [
      "React",
      "React Hooks",
      "React Icons",

      "Tailwind CSS",
      "LocalStorage",

      "Node JS",
      "Express JS",

      "JWT",

      "Cookie Parser",
    ],
    title: "Student management System",
    description: "NxtTrendz App is e-commerce similar to Amazon and Flipkart.",
    category: "business",
    liveLink: "https://student-frontend-omega.vercel.app/",
    codeLink: "https://github.com/jjtrendz",
  },

{
    id: 8,
    mainImage: "https://i.ibb.co/Y4KHL6Jp/Screenshot-2026-04-18-173023.png",
    img: [
      "https://i.ibb.co/bjwFxT3d/Screenshot-2026-02-17-011841.png",
      "https://i.ibb.co/HLMMR9jf/Screenshot-2026-02-17-011904.png",
      "https://i.ibb.co/v6Y1bHS8/Screenshot-2026-02-17-011925.png",
      "https://i.ibb.co/gbb3y2m3/Screenshot-2026-02-17-011941.png",
      "https://i.ibb.co/Wp3qzwrv/Screenshot-2026-02-17-012111.png",
      "https://i.ibb.co/ccndgKwx/Screenshot-2026-02-17-010429.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682772432/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-18_zpsewd.png",
    ],
    features: [
      "Login ",
      "Home",
      "Prime section",
      "Products",
      "Add Cart",
      "Edit Product",
      "Remove Product",
      "404 Page and many more",
      "Responsive Design",
    ],
    technologies: [
      "React",
      "React Hooks",
      "React Icons",

      "Tailwind CSS",
      "LocalStorage",

      "Node JS",
      "Express JS",

      "JWT",

      "Cookie Parser",
    ],
    title: "AI powered TODO System",
    description: "NxtTrendz App is e-commerce similar to Amazon and Flipkart.",
    category: "business",
    liveLink: "https://simple-three-theta.vercel.app//",
    codeLink: "https://github.com/jjtrendz",
  },


];




export default Items;
